<div class="container mt-4 mb-5">
	<h2>{{ attrition.id ? 'Edit Attrition' : 'Add Attrition' }}</h2>
	<form #attritionForm="ngForm" (ngSubmit)="onSubmit(attritionForm)" class="mt-3">
		<!-- Attrition Details -->
		<div class="card mb-4">
			<div class="card-header fw-bold bg-primary text-white shadow">Attrition Details</div>
			<div class="card-body">
				<div class="row">
                    <div class="col-md-4 mb-2">
                        <label for="status" class="form-label">Status <span class="text-danger">*</span></label>
                        <select id="status" name="status" class="form-select" [(ngModel)]="attrition.status" required>
                                <option value="" disabled>Select a status</option>
                                <option *ngFor="let status of statusOptions" [value]="status.type">{{ status.type }}</option>
                        </select>
                        <div *ngIf="attritionForm.submitted && !attrition.status" class="text-danger small">
                            Status is required.
                        </div>
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="exitDate" class="form-label">Exit Date</label>
                        <input id="exitDate" type="date" class="form-control" name="exit_date" [(ngModel)]="attrition.exit_date" />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="replacementNeeded" class="form-label">Replacement Needed <span class="text-danger">*</span></label>
                        <input id="replacementNeeded" type="text" class="form-control" name="replacement_needed" [(ngModel)]="attrition.replacement_needed" required />
                    </div>
                    <!-- Disabled fields for context -->
                    <div class="col-md-4 mb-2">
                        <label for="client" class="form-label">Client</label>
                        <input id="client" type="text" class="form-control" name="client" [(ngModel)]="attrition.client" disabled />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="employeeName" class="form-label">Employee Name</label>
                        <input id="employeeName" type="text" class="form-control" name="employee_name" [(ngModel)]="attrition.employee_name" disabled />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="role" class="form-label">Role</label>
                        <input id="role" type="text" class="form-control" name="role" [(ngModel)]="attrition.role" disabled />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="startDate" class="form-label">Start Date</label>
                        <input id="startDate" type="date" class="form-control" name="start_date" [(ngModel)]="attrition.start_date" disabled />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="days" class="form-label">Days</label>
                        <input id="days" type="number" class="form-control" name="days" [(ngModel)]="attrition.days" disabled />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label for="voluntaryInvoluntary" class="form-label">Voluntary/Involuntary</label>
                        <select id="voluntaryInvoluntary" class="form-select" name="voluntary_involuntary" [(ngModel)]="attrition.voluntary_involuntary" disabled>
                            <option value="">Select</option>
                            <option value="Voluntary">Voluntary</option>
                            <option value="Involuntary">Involuntary</option>
                        </select>
                    </div>
                    <div class="col-12 mb-2">
                        <label for="reasonForExit" class="form-label">Reason for Exit</label>
                        <textarea id="reasonForExit" class="form-control" name="reason_for_exit" [(ngModel)]="attrition.reason_for_exit" rows="3" placeholder="Enter reason for exit..."></textarea>
                    </div>
				</div>
			</div>
		</div>
        <div class="text-end">
            <button type="button" class="btn btn-secondary me-2" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="!attritionForm.form.valid">Submit</button>
        </div>
	</form>
</div>
